import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Box, IconButton } from '@mui/material';
import { ModalName } from 'app/enums';
import classNames from 'classnames';
import React, { FC, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { modalsReducers } from 'app/store/modal/slice';
import { BracketControlsContext } from '../../providers';
import { useStyles } from './BracketControls.styles';

const STEP = 0.08;

interface BracketControlsProps {
  isFullscreenMode?: boolean;
}

export const BracketControls: FC<BracketControlsProps> = ({ isFullscreenMode = false }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();

  const { transformComponent } = useContext(BracketControlsContext);
  const { zoomIn, zoomOut } = transformComponent ?? { zoomOut: null, zoomIn: null };

  const toggleFullScreen = useCallback(() => {
    if (!isFullscreenMode) {
      dispatch(modalsReducers.openModal({ name: ModalName.FullScreenBracket }));
      return;
    }

    dispatch(modalsReducers.closeModal(ModalName.FullScreenBracket));
  }, [isFullscreenMode, dispatch]);

  return (
    <Box className={classNames(classes.root, { [classes.fullscreen]: isFullscreenMode })}>
      <IconButton aria-label="zoomIn" size="medium" onClick={() => zoomIn?.(STEP)}>
        <ZoomInIcon fontSize="inherit" />
      </IconButton>
      <IconButton aria-label="zoomOut" size="medium" onClick={() => zoomOut?.(STEP)}>
        <ZoomOutIcon fontSize="inherit" />
      </IconButton>
      <IconButton onClick={toggleFullScreen} aria-label="menu">
        {isFullscreenMode ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>
    </Box>
  );
};
